import React from "react";
import { Spin, Empty } from "antd";
import { Column } from "@ant-design/plots";

const BarChart = (props) => {
  const {
    colorFieldName,
    customColorFtn,
    formatLabelFunction,
    tooltipFormatterFunction,
    loading,
    height,
    isNoData,
    xLabel,
    yLabel,
  } = props;
  const config = {
    data: props.data,
    isGroup: true,
    xField: props.xField,
    yField: props.yField,
    seriesField: "name",
    colorField: colorFieldName,
    height: height,
    color: customColorFtn,
    label: {
      layout: [
        {
          type: "interval-adjust-position",
        },
        {
          type: "interval-hide-overlap",
        },
        {
          type: "adjust-color",
        },
      ],
      formatter: formatLabelFunction,
    },
    xAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
      title: {
        text: xLabel ? xLabel : "",
      },
    },
    yAxis: {
      label: {
        autoHide: true,
        autoRotate: false,
      },
      title: {
        text: yLabel ? yLabel : "",
      },
    },
    tooltip: {
      formatter: tooltipFormatterFunction,
    },
  };
  return loading ? (
    <div className="center-loader-bar">
      {" "}
      <Spin size="large" />
    </div>
  ) : !isNoData ? (
    <Column {...config} />
  ) : (
    <div className="center-section-empty">
      <Empty />
    </div>
  );
};
export default BarChart;
